import { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { buildAttrStackOption } from '../BuildStackedBarOptions'
import { ScoopSelector, ScoopSpinner, ScoopChip, ScoopDivider, ScoopText } from '../../../../ui'
import styles from './ProfilePanel.module.scss'

export const ProfilePanel = ({ cluster, server, selectedInbox }) => {
    /** cluster: { name, value, desc, attributes: ['eventType','deviceType',…], id } */

    const [attr, setAttr] = useState(cluster.attributes?.[0] || '')
    const [dataSet, setDataSet] = useState(null) // server response
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setAttr(cluster.attributes?.[0] || '')
        setDataSet(null)
        setLoading(false)
    }, [cluster.clusterID])

    /* fetch distribution every time 'attr' changes */
    useEffect(() => {
        if (!attr) return
        let cancelled = false
        setLoading(true)
        setDataSet(null)
        try {
            server.postData(
                {
                    action: 'profileAttribute',
                    inboxID: selectedInbox.inboxID,
                    attributeName: attr,
                    inFilterName: 'In',
                    queryFilter: cluster.queryFilter,
                },
                (result) => {
                    if (!cancelled) {
                        setLoading(false)
                        setDataSet(result)
                    }
                }
            )
        } catch (e) {
            console.error(e)
        }
        return () => {
            cancelled = true
        } // abort on unmount
    }, [attr, cluster.clusterID])

    return (
        <div className={styles.panel}>
            <div className={styles.header}>
                <ScoopText variant="h3" className={styles.title}>
                    {cluster.name}
                </ScoopText>
                <ScoopChip
                    label={`Count: ${(cluster.value ?? 0).toLocaleString()}`}
                    className={styles.countChip}
                    style={{ '--chip-background': cluster.color }}
                />
            </div>

            {cluster.attributes?.length && (
                <>
                    <ScoopDivider className={styles.divider} />
                    <div className={styles.attributeSelector}>
                        <ScoopSelector
                            label="Attribute"
                            value={attr}
                            onChange={(e) => setAttr(e.target.value)}
                            options={cluster.attributes.map((n) => ({
                                label: n,
                                value: n,
                            }))}
                            size="sm"
                        />
                    </div>
                </>
            )}

            {loading && (
                <div className={styles.loadingContainer}>
                    <ScoopSpinner size={100} />
                </div>
            )}

            {dataSet && !loading && (
                <div className={styles.chartContainer}>
                    <ReactECharts
                        key={`${cluster.clusterID}-${attr}`}
                        option={buildAttrStackOption(dataSet, attr, cluster.color)}
                        style={{
                            '--chart-height': `${Math.max(
                                (Math.min(dataSet.dataset?.rows?.length, 15) || 1) * 14 + 40,
                                120
                            )}px`,
                        }}
                        notMerge
                    />
                </div>
            )}
            <ScoopDivider className={styles.divider} />

            <ScoopText className={styles.description}>{cluster.desc}</ScoopText>
        </div>
    )
}
